var map = {
	"./blackGold/safeBox/transferFromIcon.png": 15938,
	"./brownGold/safeBox/transferFromIcon.png": 51976,
	"./darkBlue/safeBox/transferFromIcon.png": 9302,
	"./greenYellow/safeBox/transferFromIcon.png": 36413,
	"./redGold/safeBox/transferFromIcon.png": 81418,
	"./skyBlue/safeBox/transferFromIcon.png": 23459,
	"./whiteGold/safeBox/transferFromIcon.png": 77639,
	"./yellowWhite/safeBox/transferFromIcon.png": 94392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41319;